import { DetailRow } from "./DetailRow";

export type LabelValue = { label: string; value: string };

export type CoverItem = {
  /** Cover name (e.g., "General Liability") */
  name: string;
  /** Pre-formatted premium (e.g., "$500.00"), empty if none */
  premium: string;
  /** Coverage limits */
  limits: LabelValue[];
  /** Excess title (e.g., "Deductible"), empty if n/a */
  excessTitle: string;
  /** Pre-formatted excess amount (e.g., "$500"), empty if n/a */
  excessAmount: string;
  /** Pre-formatted specific excess items */
  specificExcesses: LabelValue[];
};

export type CoverSectionProps = {
  cover: CoverItem;
  /** Content rendered between the cover header and the detail rows (limits, excess) */
  afterHeader?: React.ReactNode;
  /** Content rendered after all detail rows (specific excesses) */
  afterDetails?: React.ReactNode;
};

export const CoverSection = ({
  cover,
  afterHeader,
  afterDetails,
}: CoverSectionProps) => (
  <div data-testid={`cover-section-${cover.name}`}>
    <div className="mobius-product-summary__cover-header">
      <DetailRow label={cover.name} value={cover.premium} isPrimary />
    </div>
    {afterHeader}
    {cover.limits.map(
      limit =>
        limit.label && (
          <div
            className="mobius-product-summary__detail-spacing"
            key={limit.label}
          >
            <DetailRow
              label={limit.label}
              value={limit.value}
              isPrimary={false}
            />
          </div>
        ),
    )}
    {cover.excessTitle && cover.excessAmount && (
      <div className="mobius-product-summary__detail-spacing">
        <DetailRow
          label={cover.excessTitle}
          value={cover.excessAmount}
          isPrimary={false}
        />
      </div>
    )}
    {cover.specificExcesses.map(excess => (
      <div
        className="mobius-product-summary__detail-spacing"
        key={excess.label}
      >
        <DetailRow
          label={excess.label}
          value={excess.value}
          isPrimary={false}
        />
      </div>
    ))}
    {afterDetails}
  </div>
);

CoverSection.displayName = "CoverSection";
